import { Box, Step, StepLabel, Stepper } from '@mui/material';
import { useEffect, useState } from 'react';
import { onBoardingStepperStyle } from '../../../shared/lib/theme/styleConstants';
import { LINKS, STEPS } from '../app/constants';
import PendingPromoAlert from './common/PendingPromoAlert';
import { useAppContext } from '../app/contexts/AppContext';
import { AddYourInfo } from './AddYourInfo';
import { BillingStep } from './BillingStep';
import { FinishStepper } from './FinishStepper';
import { SetUpYourPinCode } from './SetUpYourPinCode';
import { useNavigate } from 'react-router-dom';

export const OnBoardingStepper = () => {
  const { currentUser } = useAppContext();
  const [infoSteps, setInfoSteps] = useState<boolean>(false);
  const { phoneNumber, isTPinAdded, isSubscribed, phoneVerified } = currentUser || {};
  const [startIndex, setStartIndex] = useState<number>(0);
  const { customerStripeId } = isSubscribed || {};
  const [isOnboarding, setIsOnboarding] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleNext = () => {
    setStartIndex((prev) => prev + 1);
  };

  const goToOtp = () => {
    setInfoSteps(true);
  };

  useEffect(() => {
    if (!phoneVerified && phoneNumber) {
      setStartIndex(0);
    }

    if (phoneVerified) {
      setStartIndex(1);
    }
  }, [phoneNumber, phoneVerified]);

  useEffect(() => {
    if (isTPinAdded) {
      setStartIndex(2);
      !customerStripeId && setIsOnboarding(true);
    }
  }, [isTPinAdded]);

  useEffect(() => {
    if (isOnboarding) customerStripeId && setStartIndex(3);
    else customerStripeId && navigate(LINKS.DASHBOARD_LINK);
  }, [customerStripeId]);

  const returnStepperContent = () => {
    switch (startIndex) {
      case 0:
        return <AddYourInfo handleNext={handleNext} infoSteps={infoSteps} goToOtp={goToOtp} />;

      case 1:
        return <SetUpYourPinCode handleNext={handleNext} />;

      case 2:
        return <BillingStep handleNext={handleNext} />;

      case 3:
        return <FinishStepper />;

      default:
        break;
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
       {startIndex < 2 && <PendingPromoAlert />}
      <Stepper sx={onBoardingStepperStyle} activeStep={startIndex} alternativeLabel>
        {STEPS.map((label) => (
          <Step key={label} sx={{ px: 2 }}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <Box sx={{ px: 2 }}>{returnStepperContent()}</Box>
    </Box>
  );
};
